<template>
  <div class="register-page">
    <div class="page-header">
      <h2 class="page-title">资产登记</h2>
    </div>

    <filter-bar>
      <div class="filter-item">
        <span class="filter-label">资产类型</span>
        <el-select v-model="assetType" size="small" clearable placeholder="全部" style="width: 140px">
          <el-option v-for="item in assetTypes" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="filter-item">
        <span class="filter-label">所属年度</span>
        <el-select v-model="year" size="small" clearable placeholder="全部" style="width: 120px">
          <el-option v-for="item in years" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="filter-item">
        <span class="filter-label">状态</span>
        <el-select v-model="status" size="small" clearable placeholder="全部" style="width: 120px">
          <el-option
            v-for="item in assetStatuses"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <el-button type="primary" size="small" @click="loadData">查询</el-button>
    </filter-bar>

    <div class="stat-cards-row">
      <stat-card
        title="资产总量"
        :today="summary.totalQuantity.today"
        :annual="summary.totalQuantity.annual"
        :unit="summary.totalQuantity.unit"
        :annual-unit="summary.totalQuantity.unit"
        icon="el-icon-box"
        color="#409EFF"
      />
      <stat-card
        title="可用配额"
        :today="summary.available.today"
        :annual="summary.available.annual"
        :unit="summary.available.unit"
        :annual-unit="summary.available.unit"
        icon="el-icon-circle-check"
        color="#67C23A"
      />
      <stat-card
        title="冻结/锁定"
        :today="summary.frozen.today"
        :annual="summary.frozen.annual"
        :unit="summary.frozen.unit"
        :annual-unit="summary.frozen.unit"
        icon="el-icon-lock"
        color="#E6A23C"
      />
      <stat-card
        title="资产估值"
        :today="summary.totalValue.today"
        :annual="summary.totalValue.annual"
        :unit="summary.totalValue.unit"
        :annual-unit="summary.totalValue.unit"
        icon="el-icon-money"
        color="#1a3a5c"
      />
    </div>

    <div class="table-section">
      <div class="table-toolbar">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openDialog()">
          新增资产
        </el-button>
      </div>
      <el-table :data="assets" border stripe size="small">
        <el-table-column prop="assetNo" label="资产编号" width="140" />
        <el-table-column prop="assetType" label="资产类型" width="110" />
        <el-table-column prop="quantity" label="数量 (tCO2)" min-width="130" align="right">
          <template slot-scope="{ row }">{{ formatNumber(row.quantity, 0) }}</template>
        </el-table-column>
        <el-table-column prop="source" label="取得方式" width="110" />
        <el-table-column prop="acquireDate" label="取得日期" width="120" />
        <el-table-column prop="expireDate" label="有效期至" width="120" />
        <el-table-column prop="statusLabel" label="状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusTagType(row.status)" size="mini">{{ row.statusLabel }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openDetail(row)">查看详情</el-button>
            <el-button type="text" size="small" @click="openDialog(row)">编辑</el-button>
            <el-button type="text" size="small" class="text-danger" @click="handleDelete(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="dialogMode === 'create' ? '新增资产' : '编辑资产'"
      :visible.sync="dialogVisible"
      width="520px"
      @closed="resetForm"
    >
      <el-form ref="assetForm" :model="assetForm" :rules="formRules" label-width="100px" size="small">
        <el-form-item label="资产编号" prop="assetNo">
          <el-input v-model="assetForm.assetNo" placeholder="请输入资产编号" />
        </el-form-item>
        <el-form-item label="资产类型" prop="assetType">
          <el-select v-model="assetForm.assetType" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in assetTypes" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="数量" prop="quantity">
          <el-input-number v-model="assetForm.quantity" :min="1" :step="1000" style="width: 100%" />
        </el-form-item>
        <el-form-item label="取得方式" prop="source">
          <el-select v-model="assetForm.source" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in assetSources" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="所属年度" prop="year">
          <el-select v-model="assetForm.year" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in years" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="取得日期" prop="acquireDate">
          <el-date-picker
            v-model="assetForm.acquireDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="有效期至" prop="expireDate">
          <el-date-picker
            v-model="assetForm.expireDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="assetForm.status" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in assetStatuses"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="assetForm.remark" type="textarea" :rows="3" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="saveAsset">保存</el-button>
      </div>
    </el-dialog>

    <el-drawer
      :title="currentAsset ? currentAsset.assetNo : '资产详情'"
      :visible.sync="drawerVisible"
      size="480px"
      direction="rtl"
    >
      <div v-if="currentAsset" class="drawer-content">
        <el-descriptions :column="1" border size="small" class="detail-block">
          <el-descriptions-item label="资产编号">{{ currentAsset.assetNo }}</el-descriptions-item>
          <el-descriptions-item label="资产类型">{{ currentAsset.assetType }}</el-descriptions-item>
          <el-descriptions-item label="数量">
            {{ formatNumber(currentAsset.quantity, 0) }} tCO2
          </el-descriptions-item>
          <el-descriptions-item label="取得方式">{{ currentAsset.source }}</el-descriptions-item>
          <el-descriptions-item label="所属年度">{{ currentAsset.year }}</el-descriptions-item>
          <el-descriptions-item label="取得日期">{{ currentAsset.acquireDate }}</el-descriptions-item>
          <el-descriptions-item label="有效期至">{{ currentAsset.expireDate }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="statusTagType(currentAsset.status)" size="mini">
              {{ currentAsset.statusLabel }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="资产估值">
            {{ formatNumber(currentAsset.quantity * 78.5 / 10000, 2) }} 万元
          </el-descriptions-item>
        </el-descriptions>
        <div class="detail-block">
          <div class="block-title">备注说明</div>
          <p class="remark-text">{{ currentAsset.remark || '暂无备注' }}</p>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import FilterBar from '@/components/common/FilterBar.vue'
import StatCard from '@/components/common/StatCard.vue'
import { getRegisterData } from '@/api/modules/carbonAsset'
import { formatNumber } from '@/utils/format'

const emptyForm = () => ({
  id: null,
  assetNo: '',
  assetType: '',
  quantity: 10000,
  source: '',
  year: '2025',
  acquireDate: '',
  expireDate: '',
  status: 'available',
  remark: ''
})

export default {
  name: 'CarbonAssetRegister',
  components: { FilterBar, StatCard },
  data() {
    return {
      assetType: '',
      year: '',
      status: '',
      assetTypes: [],
      assetSources: [],
      assetStatuses: [],
      years: [],
      summary: {
        totalQuantity: { today: 0, annual: 0, unit: 'tCO2' },
        available: { today: 0, annual: 0, unit: 'tCO2' },
        frozen: { today: 0, annual: 0, unit: 'tCO2' },
        totalValue: { today: 0, annual: 0, unit: '万元' }
      },
      assets: [],
      allAssets: [],
      dialogVisible: false,
      dialogMode: 'create',
      assetForm: emptyForm(),
      formRules: {
        assetNo: [{ required: true, message: '请输入资产编号', trigger: 'blur' }],
        assetType: [{ required: true, message: '请选择资产类型', trigger: 'change' }],
        quantity: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        source: [{ required: true, message: '请选择取得方式', trigger: 'change' }],
        year: [{ required: true, message: '请选择所属年度', trigger: 'change' }],
        acquireDate: [{ required: true, message: '请选择取得日期', trigger: 'change' }],
        expireDate: [{ required: true, message: '请选择有效期', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      drawerVisible: false,
      currentAsset: null,
      nextId: 100
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    formatNumber,
    async loadData() {
      const res = await getRegisterData({
        assetType: this.assetType,
        year: this.year,
        status: this.status
      })
      const data = res.data
      this.assetTypes = data.assetTypes
      this.assetSources = data.assetSources
      this.assetStatuses = data.assetStatuses
      this.years = data.years
      if (!this.allAssets.length) {
        this.allAssets = data.assets.map(item => ({ ...item }))
      }
      this.applyFilters()
    },
    applyFilters() {
      let list = [...this.allAssets]
      if (this.assetType) {
        list = list.filter(item => item.assetType === this.assetType)
      }
      if (this.year) {
        list = list.filter(item => item.year === this.year)
      }
      if (this.status) {
        list = list.filter(item => item.status === this.status)
      }
      this.assets = list
      this.updateSummary(list)
    },
    updateSummary(list) {
      const totalQuantity = list.reduce((sum, item) => sum + item.quantity, 0)
      const available = list
        .filter(item => item.status === 'available')
        .reduce((sum, item) => sum + item.quantity, 0)
      const frozen = list
        .filter(item => item.status === 'frozen')
        .reduce((sum, item) => sum + item.quantity, 0)
      const totalValue = totalQuantity * 78.5 / 10000
      this.summary = {
        totalQuantity: { today: totalQuantity, annual: totalQuantity, unit: 'tCO2' },
        available: { today: available, annual: available, unit: 'tCO2' },
        frozen: { today: frozen, annual: frozen, unit: 'tCO2' },
        totalValue: { today: totalValue, annual: totalValue, unit: '万元' }
      }
    },
    statusTagType(status) {
      const map = {
        available: 'success',
        frozen: 'warning',
        fulfilled: 'info'
      }
      return map[status] || 'info'
    },
    getStatusLabel(status) {
      const item = this.assetStatuses.find(s => s.value === status)
      return item ? item.label : status
    },
    openDialog(row) {
      if (row) {
        this.dialogMode = 'edit'
        this.assetForm = { ...row }
      } else {
        this.dialogMode = 'create'
        this.assetForm = emptyForm()
      }
      this.dialogVisible = true
    },
    resetForm() {
      this.assetForm = emptyForm()
      if (this.$refs.assetForm) {
        this.$refs.assetForm.resetFields()
      }
    },
    saveAsset() {
      this.$refs.assetForm.validate(valid => {
        if (!valid) return
        const payload = {
          ...this.assetForm,
          statusLabel: this.getStatusLabel(this.assetForm.status)
        }
        if (this.dialogMode === 'create') {
          payload.id = this.nextId++
          this.allAssets.unshift(payload)
          this.$message.success('新增成功')
        } else {
          const index = this.allAssets.findIndex(item => item.id === payload.id)
          if (index > -1) {
            this.allAssets.splice(index, 1, payload)
          }
          this.$message.success('保存成功')
        }
        this.dialogVisible = false
        this.applyFilters()
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除资产「${row.assetNo}」？`, '提示', { type: 'warning' })
        .then(() => {
          this.allAssets = this.allAssets.filter(item => item.id !== row.id)
          this.applyFilters()
          this.$message.success('删除成功')
        })
        .catch(() => {})
    },
    openDetail(row) {
      this.currentAsset = row
      this.drawerVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.stat-cards-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}

.table-section {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 16px;
}

.table-toolbar {
  margin-bottom: 12px;
}

.drawer-content {
  padding: 0 4px;
}

.detail-block {
  margin-bottom: 20px;

  .block-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
    padding-left: 8px;
    border-left: 3px solid @active-color;
  }

  .remark-text {
    font-size: 14px;
    color: @text-secondary;
    line-height: 1.6;
    margin: 0;
    padding: 8px 12px;
    background: #f5f7fa;
    border-radius: 4px;
  }
}
</style>
